import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { OfferList } from "../components/exchange/offer";
import { EscrowManager } from "../components/exchange/escrow";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`exchange-tabpanel-${index}`}
      aria-labelledby={`exchange-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export const ExchangePage: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Typography variant="h3" sx={{ mb: 4 }}>
        P2P Currency Exchange
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="exchange tabs"
        >
          <Tab label="Exchange Offers" id="exchange-tab-0" />
          <Tab label="My Escrow" id="exchange-tab-1" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <OfferList />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <EscrowManager />
      </TabPanel>
    </Box>
  );
};
